import angular from 'angular';
import attestComponent from './attest.component';

export default angular.module('components.app.common.attest', [])
  .component('attest', attestComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/attest/attest.module.js